import React, { useEffect, useState, useContext, useMemo } from "react";
import Moment from "moment";
import {
  Checkbox,
  PrimaryButton,
  ResponsiveMode,
  TextField,
} from "@fluentui/react";
import { Link, useNavigate } from "react-router-dom";
import { ACTIONS, AuthRoutes, USERTYPES } from "../../constants/Constants";
import AddButton from "../../components/AddButton";
import styles from "../Hospital/hospital.module.css";
import DataTable from "../../components/DataTable/DataTable";
import {
  getHopitalsList,
  changeStatusClient,
  getProvidersList,
} from "../../service/FirmServices";
import { connectionToProvider } from "../../service/ConnectionServices";
import { Modal } from "@fluentui/react";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { DefaultButton, IconButton } from "@fluentui/react/lib/Button";
import { ReactQueryDevtools } from "react-query/devtools";
import ColumnsProvider from "./ColumnsProvider";
import stylesProvider from "./provider.module.css";
import userContext from "../../context/users/UserContext";
import PageHeader from "../../components/PageHeader";
import { t } from "i18next";
import { changeUserLockStatus, fetchEditUserData } from "../../service/UserService";
import ListView from "../../components/ListView/ListView";
import ModalHeader from "../../components/Modal/ModalHeader";
import Connection from "../Client/Connection";
import ModalFooter from "../../components/Modal/ModalFooter";
import ModalMain from "../../components/Modal/ModalMain";
import loaderContext from "../../context/loader/LoaderContext";
import ListViewV2 from "../../components/ListViewV2/ListViewV2";
import ListViewV3 from "../../components/ListViewV3/ListViewV3";
import PasswordResetModal from "../../components/PasswordResetModal/PasswordResetModal";
const queryClient = new QueryClient();

const ProviderList = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchClicked, setSearchClicked] = useState(false);
  const [updateCurrentPage, setUpdateCurrentPage] = useState(false);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const [paginationObj, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [filterObj, setFilterObj] = useState({
    filterInput: null,
    filterUpdate: 0,
  });
  const [sortObj, setSortObj] = useState({
    sortFieldText: "",
    sortFieldValue: "",
    sortDir: false,
    selected: false,
  });
  const [code, setCode] = useState("");
  const [radiologistCode, setRadiologistCode] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [isRadiologistModalOpen, setRadiologistModalOpen] = useState(false);
  const [onPayroll, setOnPayroll] = useState(false);
  const [selectedRowObj, setSelectedRowObj] = useState({ index: 0 });
  const addIcon = { iconName: "Add", style: { fontSize: 13, lineHeight: 1.5 } };
  const [displayListAppliedFilter, setDisplayListAppliedFilter] = useState([]);
  const [dataQueryState, setDataQueryState] = useState({});
  const { roles, authenticated, loadByUsername, userId } =
    useContext(userContext);

  const connectIcon = {
    iconName: "Merge",
    style: { fontSize: 13, lineHeight: 1.5 },
  };
  const cancelIcon = {
    iconName: "Cancel",
    style: { fontSize: 13, lineHeight: 1.5 },
  };
  const [errorMsg, setErrorMsg] = useState("");
  const [success, setSuccess] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [isConnectionSuccessfull, setIsConnectionSuccessfull] = useState(false);
  const [selectedUsername, setSelectedUsername] = useState("");
  const [showResetModal, setShowResetModal] = useState(false);
  const [fullName,setFullName]=useState("");

  const clearIcon = {
    iconName: "12PointStar",
    style: { fontSize: 13, lineHeight: 1.5 },
  };

  const fetchProviderList = async (options) => {
    console.log("INSIDE FETCH PROVIDER LIST");
    let sortParams = "id";
    let sortyByDir = false;

    if (
      options.sortObj.sortFieldValue != undefined &&
      options.sortObj.sortFieldValue.length > 0
    ) {
      sortParams = options.sortObj.sortFieldValue;
      sortyByDir = options.sortObj.sortDir;
    }

    const body = {
      paginationDto: {
        pageNumber: options.page,
        pageSize: 10,
        sortField: camelToUnderscore(sortParams),
        sortOrder: sortyByDir,
        filterInput:
          options.filterObj.filterInput == null
            ? ""
            : options.filterObj.filterInput,
      },
    };

    setLoaderRunning(true);
    ref.current.continuousStart();

    try {
      const response = await getProvidersList(body);
      let data = null;
      let pageCount = null;
      if (response.status === 200 && response.data.result === "SUCCESS") {
        setLoaderRunning(false);
        ref.current.complete();
        data = response.data.data.providerPage.content;
        pageCount = response.data.data.providerPage.totalPages;

        return {
          rows: data,
          pageCount: pageCount,
        };
      } else {
        setLoaderRunning(false);
        ref.current.complete();
        return {
          rows: data,
          pageCount: pageCount,
        };
      }
    } catch (e) {
      console.log(e);
      //setLoading(false);
    }
  };

  function camelToUnderscore(key) {
    var result = key.replace(/([A-Z])/g, " $1");
    return result.split(" ").join("_").toLowerCase();
  }

  function ReloadData(id, statusOrLocked) {
      // setUpdateCurrentPage(() => !updateCurrentPage);
      // setFilterObj({ ...filterObj, activeStatus: updateCurrentPage, row: data });
       let newIndex = -1;
       let newData = dataQueryState?.data?.rows.filter((row, index) => {
         if (row.id == id) {
           newIndex = index;
           return true;
         }
         return false;
       });  
       setDataQueryState(() => {
         const newValue = {
           ...dataQueryState
         };
         if(newValue.data.rows[newIndex] != null){
          if(statusOrLocked){
            if(newValue.data.rows[newIndex].status == "Active"){
              newValue.data.rows[newIndex].status = "Inactive"; 
            }else{
              newValue.data.rows[newIndex].status = "Active"; 
            }
          }else if(!statusOrLocked){
            newValue.data.rows[newIndex].accountNonLocked = !newValue.data.rows[newIndex].accountNonLocked;
          }
         }
         return newValue;
       });
  }

  const connectProvider = async () => {
    if (code.length == 0) {
      isRadiologistModalOpen ?
      setErrorMsg(t("hospital.radiologist-code-required")) : setErrorMsg(t("hospital.firm-code-required"));
      return;
    } else {
      setErrorMsg("");
    }
    setLoading(true);
    const body = {
      connectionDto: {
        id: null,
        clientId: null,
        providerId: null,
        radiologistId: null,
        status: null,
        onPayroll: isRadiologistModalOpen ? onPayroll : null,
        qcRadiologist: 0,
        codeRadiologist: isRadiologistModalOpen ? code : null,
        firmCodeProvider: isRadiologistModalOpen ? null : code,
        firmCodeClient: null,
        currentUserId: null,
        showAllStudies: 0,
        qcEnabled: 0,
        twoSignaturesAllowed: 0,
        modalityIds: null,
      },
    };
    try {
      setLoaderRunning(true);
      ref.current.continuousStart();
      const response = await connectionToProvider(body, true);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        setIsConnectionSuccessfull(true);
        setSuccessMsg(response.data.message);
        setSuccess(true);
        setLoading(false);
        setLoaderRunning(false);
        ref.current.complete();
      } else if (
        response.status === 200 &&
        response.data.result === "FAILURE"
      ) {
        const res = response.data.data.errors;
        if (res.length > 0) {
          setErrorMsg(res[0].defaultMessage);
        }
        setLoaderRunning(false);
        ref.current.complete();
      }
    } catch (e) {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const handleClickGroup = async (event, data, cell) => {
    event.stopPropagation();
    try {
      const response = await changeStatusClient(
        cell.row.original.connectionId,
        "PROVIDER",
        cell.row.original.firmActive ? false : true
      );
      if (response.status === 200 && response.data.result === "SUCCESS") {
        // if (event.target.innerText === "Active") {
        //   event.target.innerText = "Deactive";
        // } else if (event.target.innerText === "Deactive") {
        //   event.target.innerText = "Active";
        // }
        ReloadData(data, true);
      }
    } catch (e) {
      console.log(e);
    }
    console.log("after");
    console.log(cell);
  };

  const handleProviderClick = async (cell) => {
    if (cell.type != "Radiologist") {
      //need changes as per firm
      navigate(
        AuthRoutes.FIRMDETAILS +
          "?firmId=" +
          cell.id +
          "&type=" +
          1 +
          "&viewRequestForRole=RADIOLOGIST",
        {
          state: {
            action: ACTIONS.VIEW,
            loggedInUserId: userId,
            userId: cell.id,
            loggedInUserRole: roles[0],
            //userType: USERTYPES.RADIOLOGIST
          },
        }
      );
    } else {
      navigate(
        AuthRoutes.PROVIDERVIEW +
          "?providerId=" +
          cell.id +
          "&type=" +
          cell.type,
        {}
      );
    }
  };

  const handleConnectProviderClick = (type) => {
    if(type === "Radiologist") {
      setRadiologistModalOpen(true)
    }
    setIsConnectionSuccessfull(false);
    setModalOpen(true);
  };


  const handleLockButton = async (event, data, cell) => {
    event.stopPropagation();
    try {
      const response = await changeUserLockStatus(data);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        // handleCaching(data);
        ReloadData(data, false);
      }
    } catch (e) {
      console.log(e);
    }
  };
    
  
  const openPasswordReset = (event,fullName,username) => {
    event.stopPropagation(); 
    setSelectedUsername(username);
    setShowResetModal(true);
    setFullName(fullName);
  }; 


  const columns = ColumnsProvider(
    handleClickGroup,
    userId,
    roles,
    handleProviderClick,
    handleConnectProviderClick,
    handleLockButton,
    openPasswordReset
  );

  useEffect(() => {
    setCode("");
    setErrorMsg("");
    setSuccess(false);
    setSuccessMsg("");
  }, [isModalOpen]);

  useEffect(() => {
    if (success && !isModalOpen) {
      setUpdateCurrentPage(() => !updateCurrentPage);
      setFilterObj({
        ...filterObj,
        activeStatus: updateCurrentPage,
        row: null,
      });
    }
  }, [success, isModalOpen]);

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, []);

  const buttonsTopBar = [
    {
      key: "1",
      button: (
        <Link
          key="1"
          to={AuthRoutes.MYADDRADIOLOGIST}
          // state={{
          //   action: ACTIONS.ADD,
          //   loggedInUserId: userId,
          //   loggedInUserRole: roles[0],
          //   userType: USERTYPES.RADIOLOGIST,
          // }}
        >
          <div className="add-button-list-view">
            <PrimaryButton
              text={t("radiologist.add-radiologist")}
              className={
                "common-default-active-button list-view-top-buttons-styles"
              }
            />
          </div>
        </Link>
      ),
    },
    {
      key: "2",
      button: (
        <div className="add-button-list-view">
          <PrimaryButton
            key="2"
            text={t("button.connect-firm")}
            iconProps={connectIcon}
            className={
              "common-default-active-button list-view-top-buttons-styles"
            }
            onClick={() => {
              setRadiologistModalOpen(false);
              setIsConnectionSuccessfull(false);
              setModalOpen(true);
            }}
            responsiveMode={ResponsiveMode.large}
          />
        </div>
      ),
    },
    {
      key: "3",
      button: (
        <div className="add-button-list-view">
          <PrimaryButton
            key="3"
            className={
              "common-default-active-button list-view-top-buttons-styles"
            }
            text={t("button.connect-radiologist")}
            iconProps={connectIcon}
            onClick={() => {
              setRadiologistModalOpen(true);
              setIsConnectionSuccessfull(false);
              setModalOpen(true);
            }}
          />
        </div>
      ),
    },
  ];

  const options = [
    { key: "name", text: "Name" },
    { key: "email", text: "Email" },
    // { key: "mobile", text: "Mobile" },
    { key: "active", text: "Action" },
  ];

  const hideConnectionModal = () => {
    setModalOpen(false);
  };

  let PrimaryButtonList = [
    {
      title: t("button.connect"),
      onclick: connectProvider,
    },
  ];
  let DefaultButtonList = [
    {
      title: isConnectionSuccessfull ? t("button.close") : t("button.cancel"),
      onclick: hideConnectionModal,
    },
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        showPatientDetails={false}
        heading={
          isConnectionSuccessfull ? t("confirm-message.alert") :
          isRadiologistModalOpen
            ? t("hospital.connect-radiologist")
            : t("hospital.connect-provider")
        }
        handleCancel={hideConnectionModal}
      />
    ),
    body: (
      <Connection
        isRadiologistModalOpen={isRadiologistModalOpen}
        onPayroll={onPayroll}
        setOnPayroll={setOnPayroll}
        success={success}
        successMsg={successMsg}
        label={
          isRadiologistModalOpen
            ? t("radiologist.radiologist-code")
            : t("hospital.firm-code")
        }
        setCode={setCode}
        code={code}
        setErrorMsg={setErrorMsg}
        errorMsg={errorMsg}
      />
    ),
    footer: (
      <ModalFooter
        PrimaryButtonList={!isConnectionSuccessfull ? PrimaryButtonList : null}
        DefaultButtonList={DefaultButtonList}
      />
    ),
    width: "500px",
  };

  const handleUserClick = async (cell) => {
    cell = cell.row.original;
    if (cell.type === "Radiologist") {
      navigate(
        AuthRoutes.PROVIDERVIEW +
          "?providerId=" +
          cell.id +
          "&type=" +
          cell.type
      );
    } else {
      navigate(AuthRoutes.FIRMDETAILS + "?firmId=" + cell.id + "&type=1");
    }
  };

  const handleApplyClick = (filterValue) => {
    if(filterValue != undefined)filterValue = filterValue.trim();
    setPagination(()=>{
      const newItem = {...paginationObj};
      newItem.pageIndex = 0;
      return newItem;
    });
    setTimeout(()=>{
    setFilterObj(() => {
      const newItem = { ...filterObj };
      newItem.filterInput = filterValue;
      newItem.filterUpdate = newItem.filterUpdate + 1;
      return newItem;
    });
    },100);
  };

  return (
    <><PasswordResetModal
        username={selectedUsername}
        visible={showResetModal}
        onClose={() => setShowResetModal(false)}
        fullName={fullName}
      />
      <ListViewV3
        buttonsTopBar={buttonsTopBar}
        sortDropdownOptions={options}
        fetchData={fetchProviderList}
        columns={columns}
        handleUserClick={handleUserClick}
        filterObj={filterObj}
        setFilterObj={setFilterObj}
        sortObj={sortObj}
        setSortObj={setSortObj}
        setPagination={setPagination}
        paginationObj={paginationObj}
        setDataQueryState={setDataQueryState}
        dataQueryState={dataQueryState}
        handleApplyClick={handleApplyClick}
        uniqueKey={"Provider"}
        heading={t("navbar.providers")}
        placeholder={t("placeholder.provider-name")}
      />
      <ModalMain modalDetails={modalDetails} showModal={isModalOpen} />
    </>
  );
};

export default ProviderList;
